<template>
  <div>
    <vue-ins-progress-bar />
    <div v-if="notAllowed">
      <LocationNotAllowed />
    </div>
    <div v-else>
      <component :is="layout">
        <RouterView />
      </component>
    </div>
    <div
      id="scroll-to-top"
      class="scrolltop text-center"
    >
      <i
        class="fas fa-chevron-up"
        style="font-size: 20px;"
      />
    </div>
    <div id="swal-output" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { Network } from '@capacitor/network'

import MainLayout from '@/components/layouts/MainLayout.vue'
import AuthorizationLayout from '@/components/layouts/AuthorizationLayout.vue'
import BlankLayout from '@/components/layouts/BlankLayout.vue'
import LocationNotAllowed from './views/shared/LocationNotAllowed.vue'

import { Geolocation } from '@capacitor/geolocation'
import { fCustomers } from './forage/shared/customers'
import MxMisc from '@/mixins/misc'

export default {
  name: 'App',

  components: {
    'layout-main': MainLayout,
    'layout-auth': AuthorizationLayout,
    'layout-blank': BlankLayout,
    LocationNotAllowed
  },

  mixins: [
    MxMisc
  ],

  metaInfo () {
    const appName = process.env?.VUE_APP_TITLE || ''
    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  data () {
    return {
      watcherId: null,
      notAllowed: false
    }
  },

  computed: {
    ...mapGetters({
      offline: 'offline-storage/offlineState',
      user: 'auth/user'
    }),

    layout () {
      switch (this.$route.meta.layout) {
        case 'auth': {
          return 'layout-auth'
        }
        case 'sso': {
          return 'layout-blank'
        }
        default: {
          if (this.user?.id) {
            return 'layout-main'
          }

          return 'layout-auth'
        }
      }
    }
  },

  mounted () {
    this.initListener()
    this.$insProgress.finish()

    if (!this.isMobile()) {
      fCustomers.length().then(
        length => {
          if (Number(length) > 0) {
            fCustomers.clear()
          }
        }
      )
    }
  },

  beforeDestroy () {
    Network.removeAllListeners()

    if (this.watcherId) {
      navigator.geolocation.clearWatch(this.watcherId)
    }
  },

  methods: {
    initListener () {
      Geolocation.checkPermissions().then(
        status => {
          this.notAllowed = ['denied', 'prompt'].includes(status.location)

          this.watcherId = navigator.geolocation.watchPosition(
            () => {
              this.notAllowed = false
            }, () => {
              this.notAllowed = ['denied', 'prompt'].includes(status.location)
            }, {
              enableHighAccuracy: false, // disable for long checking of more precise location
              timeout: 3000,
              maximumAge: 60000
            }
          )
        }
      )

      Network.addListener('networkStatusChange', networkConnection => {
        this.$bvToast.toast(networkConnection.connected ? 'Internet connection restored' : 'You are currently working offline', {
          title: 'Network Status',
          toaster: 'b-toaster-bottom-center',
          solid: true,
          appendToast: true,
          noCloseButton: true,
          autoHideDelay: 3000,
          variant: networkConnection.connected ? 'success' : 'danger'
        })

        this.offlineAction(!networkConnection.connected)
      })
    },

    ...mapActions({
      offlineAction: 'offline-storage/offlineAction'
    })
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/style.scss";
</style>
<style>
  @import "./assets/css/custom.css";
</style>
